module.exports = __webpack_public_path__ + "static/media/logoCircle.39a14798.svg";